import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getApiData, getApiRecord } from 'services/SalesOrdersService'

export const getData = createAsyncThunk('inboundDelivery/data/getData', async data => {
    const response = await getApiData(data)
    return response.data
})

export const getRecord = createAsyncThunk('inboundDelivery/data/getRecord', async id => {
    const response = await getApiRecord(id)
    return response.data
})

const recordData = {
    site: '',
    client: '',
    shipment: '',
    customer: '',
    order_type: '',
    reference_1: '',
    reference_2: '',
    status: '',
    created_date: '',
    closed_date: '',
    carrier: '',
    carrier_service: '',
    tracking: '',
}

const initialTableData = {
    total: 0,
    pageIndex: 1,
    pageSize: 10,
    query: '',
    selectedTab: '',
    sort: [{ column: '', dir: '' }],
}

const dataSlice = createSlice({
    name: 'inboundDelivery/data',
    initialState: {
        loading: false,
        record: recordData,
        data: [
            {
                site: 'VIC',
                client: 'Client 1',
                shipment: 'SO9143',
                customer: 'Richard Dalton',
                order_type: 'B2C',
                reference_1: 'SO-128996-1',
                reference_2: '',
                status: 'created',
                created_date: '25-07-2025',
                closed_date: '30-07-2025',
                carrier: 'Australia Post',
                carrier_service: 'Standard',
                tracking: 'http://6305901203',
            },
            {
                site: 'VIC',
                client: 'Client 1',
                shipment: 'SO9143',
                customer: 'Richard Dalton',
                order_type: 'B2C',
                reference_1: 'SO-128996-1',
                reference_2: '',
                status: 'allocated',
                created_date: '25-07-2025',
                closed_date: '30-07-2025',
                carrier: 'Startrack',
                carrier_service: 'Express',
                tracking: 'http://6305901203',
            },
            {
                site: 'SA',
                client: 'Client 1',
                shipment: 'SO9143',
                customer: 'Richard Dalton',
                order_type: 'B2C',
                reference_1: 'SO-128996-1',
                reference_2: '',
                status: 'partially allocated',
                created_date: '25-07-2025',
                closed_date: '30-07-2025',
                carrier: 'Startrack',
                carrier_service: 'Express',
                tracking: 'http://6305901203',
            },
            {
                site: 'NSW',
                client: 'Client 1',
                shipment: 'SO9143',
                customer: 'Richard Dalton',
                order_type: 'B2B',
                reference_1: 'SO-128996-1',
                reference_2: '',
                status: 'picked',
                created_date: '25-07-2025',
                closed_date: '30-07-2025',
                carrier: 'Border Express',
                carrier_service: 'Premium',
                tracking: 'http://6305901203',
            },
            {
                site: 'QLD',
                client: 'Client 1',
                shipment: 'SO9143',
                customer: 'Richard Dalton',
                order_type: 'B2B',
                reference_1: 'SO-128996-1',
                reference_2: '',
                status: 'shipped',
                created_date: '25-07-2025',
                closed_date: '30-07-2025',
                carrier: 'Australia Post',
                carrier_service: 'Standard',
                tracking: 'http://6305901203',
            },
            {
                site: 'SA',
                client: 'Client 1',
                shipment: 'SO9143',
                customer: 'Richard Dalton',
                order_type: 'B2C',
                reference_1: 'SO-128996-1',
                reference_2: '',
                status: 'cancelled',
                created_date: '25-07-2025',
                closed_date: '30-07-2025',
                carrier: 'Australia Post',
                carrier_service: 'Express',
                tracking: 'http://6305901203',
            },
            {
                site: 'QLD',
                client: 'Client 1',
                shipment: 'SO9143',
                customer: 'Richard Dalton',
                order_type: 'B2B',
                reference_1: 'SO-128996-1',
                reference_2: '',
                status: 'closed',
                created_date: '25-07-2025',
                closed_date: '30-07-2025',
                carrier: 'Border Express',
                carrier_service: 'Premium',
                tracking: 'http://6305901203',
            },
        ],
        tableData: initialTableData,
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.tableData = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
                state.tableData.total = 0
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload?.results
                state.tableData.total = payload?.count
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
            })
            .addCase(getRecord.fulfilled, (state, { payload }) => {
                state.loading = false
                state.record = payload
            })
            .addCase(getRecord.pending, state => {
                state.loading = true
                state.record = null
            })
            .addCase(getRecord.rejected, state => {
                state.loading = false
                state.record = null
            })
    },
})

export const { setData, setTableData } = dataSlice.actions

export default dataSlice.reducer
